export default "__VITE_ASSET__C3ytqZuy__"